let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f6a21")).then(() => parcelRequire('c40YO'));